import handleValueOrFunction from '@iez/lib/handle-value-or-function'
import { reactive, onMounted, onBeforeUnmount, watch } from '@vue/composition-api'

export const state = reactive({
  blockingDrawer: null,
  model: false,
  touchless: true
})

export default () => {
  const set = ({ activeWhen, blockingDrawer }) => {
    onMounted(() => {
      state.touchless = false
      watch(
        () => state.model,
        model => {
          if (model) {
            state.blockingDrawer = blockingDrawer
          }
        }
      )
      handleValueOrFunction({
        valueOrFunction: activeWhen,
        callback: activeWhen => {
          if (activeWhen) {
            state.model = !!blockingDrawer
            state.blockingDrawer = blockingDrawer
          }
        }
      })
    })

    onBeforeUnmount(() => {
      state.touchless = true
    })
  }

  return {
    set
  }
}
